function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.3902 13.62C16.2102 13.24 15.8202 13 15.4002 13L9.10021 13.03C8.68021 13.03 8.29021 13.28 8.11021 13.65C7.93021 14.03 7.99021 14.48 8.26021 14.8L11.4302 18.6C11.6402 18.85 11.9502 19 12.2802 19C12.6102 19 12.9202 18.85 13.1302 18.6L16.2602 14.77C16.5302 14.44 16.5802 14 16.4002 13.62H16.3902Z",
  fill: "#DEE3EC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.11017 10.38C7.93017 10 7.98017 9.55 8.25017 9.23L11.3802 5.4C11.5902 5.15 11.9002 5 12.2302 5C12.5602 5 12.8702 5.14 13.0802 5.4L16.2502 9.2C16.5202 9.52 16.5802 9.97 16.4002 10.35C16.2202 10.73 15.8302 10.97 15.4102 10.97L9.11017 11C8.69017 11 8.30017 10.76 8.12017 10.38H8.11017Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=CaretSortUp.js.map